import React, { HTMLAttributes } from "react";

const Skeleton = (data: {
  width?: string;
  height: string;
  borderRadius: string;
  maxWidth?: string;
  mainClassName?: HTMLAttributes<HTMLDivElement>["className"];
}) => {
  const pulseStyle = {
    animation: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
  };

  const contentStyles = {
    backgroundColor: "#e5e7eb",
    borderRadius: data.borderRadius ?? "8px",
  };

  const elementStyles = {
    backgroundColor: "#d1d5db",
    borderRadius: "4px",
  };

  return (
    <div className={data.mainClassName}>
      <div style={{ ...contentStyles, ...pulseStyle, width: data.width, height: data.height }} />
    </div>
  );
};

export default Skeleton;
